export default __webpack_public_path__ + "static/media/bg-firefeatures.0bc885ae.jpg";